import { CLEAR_PRODUCT, FETCH_PRODUCT } from '../actions/types';

const product = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PRODUCT:
      return { ...action.payload };
    case CLEAR_PRODUCT:
      return { ...action.payload };
    default:
      return state;
  }
};

export default product;
